import React, { useState } from "react";
import { Button } from "reactstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Form, FormGroup, Row, Col, Input, Label } from "reactstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

import api from "../../../api";

const MySwal = withReactContent(Swal);

export const closeAlert = () => {
  MySwal.clickConfirm();
};

export const fireSelectInput = (options, params = {}) => {
  const _options = {};

  for (const _ of options) {
    _options[_.value] = _.label
  }

  return MySwal.fire({
    confirmButtonText: "CONFIRMA",
    // confirmButtonColor: "#6D9973",
    // cancelButtonColor: "#e0004d",
    // cancelButtonText: "ANULEAZA",
    denyButtonText: "ANULEAZA",
    // showCancelButton: true,
    showDenyButton: true,
    input: "select",
    inputOptions: _options,
    inputPlaceholder: "Selecteaza o masina",
    inputValidator: value => {
      if (!value) {
        return "Obligatoriu";
      }
    },
    ...params

  })
}

export const fireAddText = (title, icon = "warning") => {
  return MySwal.fire({
    icon,
    title,
    confirmButtonText: "Finalizeaza",
    confirmButtonColor: "#20344c",
    // cancelButtonColor: "#e0004d",
    cancelButtonText: "Anuleaza",
    showCancelButton: true,
    input: "textarea",
    inputValidator: value => {
      if (!value) {
        return "Obligatoriu"
      }
    }
  })
}

export const fireInfoAlert = (title, html) => {
  return MySwal.fire({
    title,
    html,
    position: "center",
    width: "90%",
    confirmButtonColor: "#20344c",
    customClass: {
      content: "content-class-info"
    }
  });
};

export const fireInfoAlertV2 = (title, html) => {
  return MySwal.fire({
    title,
    html,
    position: "center",
    width: "90%",
    showCancelButton: false,
    showConfirmButton: false,
    showCloseButton: false
  });
};

export const fireSelectAlert = (title, html) => {
  return MySwal.fire({
    title,
    html,
    position: "center",
    // width: "50%",
    showCancelButton: false,
    showConfirmButton: false,
    showCloseButton: true
  });
};

export const fireSelectAlertMobileView = (title, html) => {
  return MySwal.fire({
    title,
    html,
    position: "center",
    width: "95%",
    showCancelButton: false,
    showConfirmButton: false,
    showCloseButton: true
  });
};

export const fireChangePassword = (title, html) => {
  return MySwal.fire({
    title,
    html,
    icon: "warning",
    showCancelButton: false,
    showConfirmButton: false,
    customClass: {
      content: "content-class__new-lead"
    }
  });
};

export const fireSuccessAlert = (title = "Actiune finalizata cu successs", params = {}) => {
  return MySwal.fire({
    title,
    icon: "success",
    timer: 10000,
    showConfirmButton: true,
    ...params
  });
};


export const fireAreYouSure = (title, text) => {
  return MySwal.fire({
    icon: "warning",
    title,
    text,
    showDenyButton: true,
    showCancelButton: false,
    showCloseButton: false,
    showConfirmButton: true,
    // confirmButtonColor: "#6D9973",
    // denyButtonColor: "#e0004d",
    confirmButtonText: "CONFIRMA",
    denyButtonText: "ANULEAZA",
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false,
  })
}

export const fireWarningAlertV3 = (title) => {
  return MySwal.fire({
    title,
    icon: "warning",
    timer: 10000,
    showConfirmButton: true
  });
}

export const fireWarningAlert = params => {
  return MySwal.fire({
    icon: "warning",
    ...params
  })
};

export const fireWarningAlertV2 = (text, callback) => {
  return MySwal.fire({
    icon: "warning",
    title: "Atentie!",
    text: text,
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: "Renunta",
    confirmButtonText: "Continua",
    confirmButtonColor: "#20344c",
    // cancelButtonColor: "#e0004d"
  }).then(confirmation => {
    if (confirmation.value) {
      callback();
    }
  });
};

export const fireWarningAlertV4 = (html) => {
  return MySwal.fire({
    title: "Atentie!",
    icon: "warning",
    html,
    showConfirmButton: true,
    confirmButtonText: "CONTINUA",
    // confirmButtonColor: "#6D9973"
  });
}

export const fireInfoText = (title, icon) => {
  return MySwal.fire({
    title,
    icon,
    input: "text",
    inputValidator: value => {
      if (!value) {
        return "Obligatoriu"
      }
    },
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: "Anuleaza",
    confirmButtonText: "Finalizeaza",
    confirmButtonColor: "#20344c",
    cancelButtonColor: "#e0004d"
  })
}

export const fireReminders = html => {
  MySwal.fire({
    title: "Istoric",
    html,
    showCancelButton: false,
    showConfirmButton: false,
    showCloseButton: true
  });
};

export const fireWarningDeleteLead = callback => {
  return MySwal.fire({
    icon: "warning",
    input: "textarea",
    title: "Adauga motiv",
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: "Inchide lead",
    cancelButtonText: "Renunta",
    confirmButtonColor: "#20344c",
    cancelButtonColor: "#e0004d"
  }).then(options => {
    if (options.isConfirmed) {
      callback(options.value);
    }
  });
};

export const fireHtmlContainer = (title, html, params = { width: "25%" }) => {
  return MySwal.fire({
    title,
    html,
    showConfirmButton: false,
    showCloseButton: true,
    showCancelButton: false,
    showDenyButton: false,
    allowOutsideClick: true,
    allowEscapeKey: true,
    allowEnterKey: false,
    ...params
  })
}

export const fireInputAlert = (params) => {
  return MySwal.fire({
    input: "number",
    inputValidator: value => {
      if (!value) {
        return "Obligatoriu"
      }
    },
    width: "70%",
    showConfirmButton: true,
    showDenyButton: true,
    showCancelButton: false,
    allowEnterKey: true,
    allowOutsideClick: false,
    // confirmButtonColor: "#6D9973",
    // denyButtonColor: "#e0004d",
    ...params
  })
}

export const fireInputDate = async (params) => {
  const { value, isConfirmed, isDenied } = await Swal.fire({
    ...params,
    showConfirmButton: true,
    showDenyButton: true,
    html: `
      <input id="swal-input1" class="swal2-input" type="date" />
    `,
    preConfirm: () => {
      return document.getElementById("swal-input1").value
    }
  })

  if(isConfirmed){
    return value;
  }

  return null;
}

export const fireAgentPaymentQueue = () => {
  return MySwal.fire({
    width: "50%",
    title: "Depui tot soldul?",
    icon: "warning",
    showDenyButton: true,
    showConfirmButton: true,
    // confirmButtonColor: "#6D9973",
    // denyButtonColor: "#e0004d",
    confirmButtonText: "Da, depun tot soldul",
    denyButtonText: "Nu, vreau sa depun partial",
  }).then(result => {
    if (!result.isConfirmed && !result.isDenied) {
      return null;
    }

    if (result.isConfirmed) {
      return true;
    }

    if (result.isDenied) {
      return Swal.fire({
        width: "50%",
        title: "Introdu valoarea depunerii",
        icon: "warning",
        input: "number",
        inputValidator: value => {
          if (!value) {
            return "Obligatoriu"
          }
        },
        allowEnterKey: true,
        // confirmButtonColor: "#6D9973",
        confirmButtonText: "Finalizeaza depunerea",
        denyButtonText: "Anuleaza depunerea",
        // denyButtonColor: "#e0004d",
        showDenyButton: true
      })
    }
  })
}

export const fireFullScreen = (title, html) => {
  return MySwal.fire({
    title,
    html,
    position: "center",
    width: "100%",
    showConfirmButton: false,
    showCloseButton: true,
    customClass: {
      content: "expand_class"
    }
  });
};

export const fireQuestion = (params) => {
  return MySwal.fire({
    icon: "question",
    allowEscapeKey: false,
    allowOutsideClick: false,
    position: "center",
    ...params
  })
}

// export const fireComplaintQueue = () => {}

export const fireAgentReportQueue = async () => {
  const values = [];
  const swals  = [
      {
        title: "Adauga kilometraj initial",
        input: "number",
        inputPlaceholder: "....",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "MAI DEPARTE",
        cancelButtonText: "ANULEAZA",
        currentProgressStep: "1",
        width: "50%"
      },
      {
        title: "Adauga kilometraj final",
        input: "number",
        inputPlaceholder: "....",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "TRIMITE",
        cancelButtonText: "INAPOI",
        currentProgressStep: "2",
        width: "50%"
      },
    
  ];

  for(let currentStep = 0; currentStep < 2;){
    const result = await MySwal.fire(swals[currentStep]);

    if(result.isConfirmed){
      values[currentStep] = result.value;
      currentStep++;

      if(currentStep === 2){
        break;
      }
    } else{
        if(currentStep === 0){
          break;
        } else{
          if(currentStep === 1 && result.isDenied){
            values[currentStep] = false;
            break;
          } else{
            currentStep--;
          }
        }
    }
  }

  return values;
}

export const fireComplaintQueue = async () => {
  const steps = ['1', '2', '3'];
  const reasons = {
    "0": "Fibra gresita",
    "1": "Decor gresit",
    "2": "Finisaj gresit",
    "3": "Schita realizata gresit",
    "4": "Dimensiune gresita",
    "5": "Grosime gresita",
    "6": "Destinatar eronat",
    "7": "Defect productie",
    "8": "Lovit transport",
    "9": "Cantuire gresita",
    "10": "Omitere prelucrare dupa specificatii client",
    "11": "Repere prelucrate dupa livrare",
    "12": "Redimensionare solicitata de client",
    "13": "Lovituri de catre client",
    "14": "Culoare gresita de catre client",
    "15": "Finisaj gresit de catre client",
    "16": "Element doar petru vopsire/finisare",
    "17": "Fibra gresita de catre client",
    "18": "Repere lipsa",
    "19": "Modificare proiect"
  }
  const values = [];

  const swals  = [
    {
      title: "MOTIV",
      input: "select",
      inputOptions: reasons,
      inputPlaceholder: "Selecteaza un motiv...",
      inputValidator: value => {
        if(!value){
          return "Obligatoriu";
        }
      },
      showConfirmButton: true,
      showCloseButton: true,
      // showCancelButton: true,
      confirmButtonText: "ADAUGA OBSERVATII",
      // cancelButtonText: "INCHIDE",
      currentProgressStep: "1",
      width: "75%"
    },
    {
      title: "OBSERVATII",
      input: "textarea",
      inputPlaceholder: "Optional...",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "CONFIGUREAZA RECLAMATIE",
      cancelButtonText: "INAPOI",
      currentProgressStep: "2",
      width: "75%"
    },
    {
      title: "CONFIGUREAZA RECLAMATIE",
      text: "Pastrezi configuratia comenzii initiale?",
      showConfirmButton: true,
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "DA",
      denyButtonText: "NU",
      cancelButtonText: "INAPOI",
      currentProgressStep: "3",
      width: "75%"
    }
  ]

  for(let currentStep = 0; currentStep < 3;){
    const result = await MySwal.fire(swals[currentStep]);

    if(result.isConfirmed){
      values[currentStep] = result.value;
      currentStep++;

      if(currentStep === 3){
        break;
      }
    } else{
        if(currentStep === 0){
          break;
        } else{
          if(currentStep === 2 && result.isDenied){
            values[currentStep] = false;
            break;
          } else{
            currentStep--;
          }
        }
    }
  }


  return {
    reason: reasons[values[0]],
    obs: values[1],
    keepOriginalCommandConfiguration: values[2]
  }
};

export const fireAlertProductionScannedSpecialArticle = (title, text, bg) => {
  return MySwal.fire({
    title, 
    text, 
    width: "90%", 
    showCloseButton: false, 
    showDenyButton: false, 
    showConfirmButton: true, 
    allowEscapeKey: false, 
    allowEnterKey: false, 
    allowClickOutside: false, 
    confirmButtonText: "Confirma",
    timer: 3000,
    timerProgressBar: true,
    background: bg
  })
}















